export const messages = {
  nominalPrice: {
    id: 'admin/promotions.form.review.alert.regular.nominal-price',
  },
  percentualPrice: {
    id: 'admin/promotions.form.review.alert.regular.percentual-price',
  },
  nominalShipping: {
    id: 'admin/promotions.form.review.alert.regular.nominal-shipping',
  },
  maxPrice: {
    id: 'admin/promotions.form.review.alert.regular.max-price',
  },
  nominalLoyalty: {
    id: 'admin/promotions.form.review.alert.regular.nominal-loyalty',
  },
  maxShipping: {
    id: 'admin/promotions.form.review.alert.regular.max-shipping',
  },
  freeShipping: {
    id: 'admin/promotions.form.review.alert.regular.free-shipping',
  },
  percentualShipping: {
    id: 'admin/promotions.form.review.alert.regular.percentual-shipping',
  },
  gift: {
    id: 'admin/promotions.form.review.alert.regular.gift',
  },
  percentualLoyalty: {
    id: 'admin/promotions.form.review.alert.regular.percentual-loyalty',
  },
  formula: {
    id: 'admin/promotions.form.review.alert.regular.formula',
  },
  priceTable: {
    id: 'admin/promotions.form.review.alert.regular.price-table',
  },
}
